import React from 'react';

import './PartnersBanner.scss';

import partnersBanner_bg from '../../../assets/img/temp/partnersBanner_bg.jpg'

class PartnersBanner extends React.PureComponent {
  render() {

    return (
      <section className="partnersBanner">
        <img src={partnersBanner_bg} className="partnersBanner_bg"/>
        <div className="container">
          <div className="partnersBanner_content">
            <div className="partnersBanner_title">
              Tváří našeho centra se stala <br/> nejúspěšnější MISS v dějinách ČR
            </div>
            <div className="partnersBanner_name">Monika Žídková</div>
          </div>
        </div>
      </section>
    );

  }
}

export default PartnersBanner;


// WEBPACK FOOTER //
// ./src/components/Partners/PartnersBanner/PartnersBanner.js